import { defineComponent as k, resolveComponent as v, unref as e, openBlock as p, createElementBlock as l, createVNode as t, createElementVNode as m, renderSlot as b, defineAsyncComponent as s } from "vue";
import "./TermsModalLink-BxJnmPaT.js";
import "./TermsModal-CBEOKaIP.js";
import A from "@ui-kit/components/button";
import { useI18n as C } from "vue-i18n";
import { UIProgressCircular as V } from "@ui-kit/components/progress";
import { useApplicationDocuments as x } from "@versatile-credit-apply/sdk";
const P = {
  key: 0,
  class: "flex h-full flex-col items-center justify-center"
}, B = {
  key: 1,
  class: "space-y-2 py-12"
}, D = { class: "space-y-4" }, I = { class: "space-y-4" }, L = /* @__PURE__ */ k({
  __name: "ProviderApplicationDocuments",
  props: {
    providerKey: {},
    types: {}
  },
  setup(n, { expose: o }) {
    const r = n, { t: d } = C(), {
      state: i,
      isLoading: u,
      error: y,
      refresh: f
    } = x(
      () => r.providerKey,
      () => r.types
    );
    return o({
      documents: i
    }), (g, c) => {
      const a = v("i18n-t"), h = A;
      return e(u) ? (p(), l("div", P, [
        t(e(V))
      ])) : e(y) ? (p(), l("div", B, [
        t(a, {
          keypath: "error_loading.title",
          tag: "h2"
        }),
        m("div", D, [
          t(a, {
            keypath: "error_loading.message",
            tag: "p"
          })
        ]),
        m("div", I, [
          t(h, {
            id: "retry",
            label: e(d)("actions.retry"),
            onClick: c[0] || (c[0] = (T) => e(f)())
          }, null, 8, ["label"])
        ])
      ])) : b(g.$slots, "default", {
        key: 2,
        documents: e(i)
      });
    };
  }
});
function _(n) {
  const o = n;
  o.__i18n = o.__i18n || [], o.__i18n.push({
    locale: "en",
    resource: {
      actions: {
        retry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Try Again" } }
      },
      error_loading: {
        message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `We were unable to load the documents because of an error.
` } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Unable to Load Documents
` } }
      }
    }
  });
}
typeof _ == "function" && _(L);
const F = s(
  () => import("./ApplicationFooter-jfiPwdUz.js")
), S = s(
  () => import("./VersatilePrivacyPolicyLink-DoPbbvlN.js")
), W = s(
  () => import("./TermsViewer-D56bmLzI.js")
);
export {
  F as A,
  W as T,
  S as V,
  L as _
};
//# sourceMappingURL=index-NNo9Bf-Y.js.map
